import { BitField } from 'src/structures/BitField.js';

export const NotificationPreferenceBits = {
  WEB: Math.trunc(1),
  EMAIL: 1 << 1,
} as const;

export class NotificationPreferenceBitField extends BitField(NotificationPreferenceBits) {}
